import useReveal from "../hooks/useReveal";

const MARQUEE_WORDS = [
    "FREIGHT COST CONTROL",
    "SHIPMENT VISIBILITY",
    "PROCUREMENT INSIGHT",
    "CARRIER PERFORMANCE",
    "INVOICE AUDIT",
    "DETENTION & DEMURRAGE",
    "ROUTING INTELLIGENCE",
    "CONTINUOUS IMPROVEMENT",
];

export default function About() {
    const [ref, visible] = useReveal();
    return (
        <section
            id="about"
            data-testid="about-section"
            className="relative py-20 sm:py-28 lg:py-36 border-t border-white/5"
        >
            {/* Marquee tape */}
            <div className="absolute top-0 inset-x-0 overflow-hidden border-b border-white/5 bg-[#0A0A0E]" data-testid="about-marquee">
                <div className="flex marquee-track py-3 whitespace-nowrap font-mono-accent text-[11px] tracking-[0.3em] text-zinc-500">
                    {[...MARQUEE_WORDS, ...MARQUEE_WORDS].map((w, i) => (
                        <span key={i} className="px-8 flex items-center gap-8">
                            <span>{w}</span>
                            <span className="text-cyan-500">/</span>
                        </span>
                    ))}
                </div>
            </div>

            <div ref={ref} className={`reveal ${visible ? "is-visible" : ""} max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10`}>
                <div className="grid lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-4">
                        <span className="section-tag" data-testid="about-tag">About · 01</span>
                        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white mt-6 leading-tight">
                            An Australian logistics solutions company.
                        </h2>
                    </div>

                    <div className="lg:col-span-8 space-y-7">
                        <p
                            data-testid="about-mission"
                            className="text-xl sm:text-2xl text-zinc-200 leading-snug font-display tracking-tight"
                            style={{ fontWeight: 500 }}
                        >
                            WE DELVR LOGISTICS PTY LTD is focused on solving real-world supply chain
                            problems for Australian importers and exporters — helping them
                            gain better control over freight cost, visibility and operational
                            performance.
                        </p>
                        <p className="text-zinc-400 leading-relaxed text-base sm:text-lg">
                            Whether the challenge is cost visibility, carrier performance,
                            shipment planning, invoice control or procurement strategy, we
                            provide the tools, insights and support needed to make better
                            logistics decisions — and create measurable value through
                            continuous improvement.
                        </p>

                        <div className="grid sm:grid-cols-3 gap-3 pt-4">
                            <Pillar k="01" t="Identify gaps" d="Find what's costing you time, money and control." />
                            <Pillar k="02" t="Engineer fixes" d="Practical solutions, data-led decisions, no jargon." />
                            <Pillar k="03" t="Improve daily" d="Continuous improvement across your supply chain." />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

function Pillar({ k, t, d }) {
    return (
        <div className="card-glow rounded-xl p-5" data-testid={`about-pillar-${k}`}>
            <div className="font-mono-accent text-[11px] text-cyan-400">{k}</div>
            <div className="font-display text-lg text-white mt-2">{t}</div>
            <div className="text-sm text-zinc-400 mt-1.5">{d}</div>
        </div>
    );
}
